import Axios from "../AxiosConfig";
class employeeStore {

    deleteEmployee = async (uuid) => {
        const resp = await Axios.post("/employee/delete", { uuid: uuid });
        return resp.data;
    };

    archiveEmployee = async (uuid, date) => {
        const resp = await Axios.post("/employee/archive", { uuid: uuid, date: date});
        return resp.data;
    };

    getEmployeeInfo = async (uuid) => {
        const resp = await Axios.post("/employee/info", { uuid: uuid });
        return resp.data;
    }

    getPastEmployeeInfo = async (uuid) => {
        const resp = await Axios.post("/employee/info-past-employee", { uuid: uuid });
        return resp.data;
    }

}
export default new employeeStore();